export default __webpack_public_path__ + "static/media/telesaleshelp-detail-mobileE.e234a77c.png";